import { render, staticRenderFns } from "./MksTemplateAdapter.vue?vue&type=template&id=3655ed19&scoped=true&"
import script from "./MksTemplateAdapter.vue?vue&type=script&lang=ts&"
export * from "./MksTemplateAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3655ed19",
  null
  
)

export default component.exports